/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Großes Hauptbild der Produktgruppe anzeigen
 *
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import UploadArea from "../../partials/UploadArea";
import { IconPortfolio, FabIconDelete } from "../../partials/Icons";
import { ImageLoader } from "../../partials/ImageLoader";

import * as utils from "../../../basics/utils";

import * as portfolioActions from '../../../store/actions/portfolioActions';
import * as fileActions from "../../../store/actions/fileActions";
import * as appActions from "../../../store/actions/appActions";

class GroupMainImage extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { unitHeight, path, appModus } = this.props.app;

        const dialog = utils.getDialogByPath(path);

        // ###############################################################
        // renderImage / Navigation
        // ---------------------------------------------------------------
        // Hier wird das große Produktbild angezeigt 
        // ###############################################################
        const renderImage = () => {

            if (!this.props.node) return null;

            if (appModus === 'Admin') {
                const nodeImage = utils.getPortfolioImage(this.props.node, path, 'main');

                const onDelete = () => {

                    const onDeleteSuccess = (data) => {
                        this.props.scanPortfolio(dialog.portfolio);
                    }

                    const onDeleteError = (error) => {
                        console.log('onDelete() error:', error);
                    }

                    this.props.deleteFile('portfolio', path, nodeImage.fileName, onDeleteSuccess, onDeleteError);
                }

                const style = utils.getStyleBackgroundURL(nodeImage.url);

                if (nodeImage.fileName === '') {
                    return (<UploadArea uploadArea='image' uploadType='portfolio' uploadPath={dialog.portfolio} uploadPost='main' />)
                } else {
                    return (
                        <div className="relative w-full h-full z-25" style={style}>
                            {FabIconDelete("Bild entfernen", onDelete)}
                        </div>
                    )
                }

            } else {
                const onClick = () => { this.props.setPath('') }

                const fileObj = utils.getFileInNode(this.props.node, 'main');
                if (!fileObj) return null;

                return (
                    <div className="w-full h-full z-25" onClick={onClick}>
                        <ImageLoader path={fileObj.path} name={fileObj.name} height={'100%'} cover={'cover'} />
                    </div>
                )
            }
        }

        // ###############################################################
        // renderIconPortfolio / Navigation
        // ---------------------------------------------------------------
        // PortfilioIcon anzeigen
        //           +----+ 
        //           | LT | 
        //           +----+ 
        // ###############################################################
        const renderIconPortfolio = () => {

            const portfolio = utils.getPortfolio(dialog.portfolio);

            return (
                <div className="absolute bottom-2 right-4 p-2">
                    {IconPortfolio(portfolio, unitHeight * 3, () => this.props.setPath(dialog.portfolio))}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        return (
            <div className="relative w-full h-full flex flex-col p-2">
                {renderImage()}
                <div className="absolute bottom-0 w-full flex font-bold">
                    <div className="w-5/6 flex p-2">
                    </div>
                    <div className="w-1/6 flex h-full">
                        {renderIconPortfolio()}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMainImage);
